import React from 'react';

import RetailContributionsEditor from '../../Buy/BuyFlow/RetailContributionsEditor/RetailContributionsEditor';
import { collegeMaxPlanLimits } from '../../../settings/settings';

const CollegeContributeFundEditor = (props) => {
  const {
    fund: { productType },
  } = props;
  const { max } = collegeMaxPlanLimits[productType] || 500000; // default to 500000 if not valid
  return <RetailContributionsEditor collegePlanMaxValue={max} {...props} />;
};

export default CollegeContributeFundEditor;
